export enum jobScheduleStatus {
    Unscheduled = "Unscheduled",
    Active = "Active",
    Inactive = "Inactive",
    Complete = "Complete"
}